<a id="csv-donwload"></a>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <div class="grid">
    <div class="col-12">
      <label for="ms-groupedArea">都道府県での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedArea"
          [group]="true"
          [(ngModel)]="selectedArea"
          (onChange)="doChangeArea($event)"
          placeholder="表示したい都道府県を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearArea()"
          pTooltip="選択解除"
          [disabled]="selectedArea.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedStores">店舗での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedStores"
          [group]="true"
          [(ngModel)]="selectedStores"
          (onChange)="doChangeStores($event)"
          placeholder="表示したい店舗を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearStores()"
          pTooltip="選択解除"
          [disabled]="selectedStores.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedStores">登録日時での絞り込み</label>
      <div class="card justify-content-center p-label">
        <p-select
          [options]="registrationDateOptions"
          [(ngModel)]="filterRegistrationDate"
          (onChange)="doChangeRegistrationDate($event)"
          optionLabel="name"
          placeholder="登録日時" />
      </div>
    </div>
    <div class="col-12">
      <div class="flex align-items-center gap-1">
        <p-checkbox
          [(ngModel)]="showFound"
          inputId="showFound"
          [binary]="true"
          (onChange)="reloadStocks($event)"></p-checkbox>
        <label for="showFound">店頭無・店員無の店舗を非表示にする</label>
      </div>
    </div>
    <div class="col-12">
      <div class="flex align-items-center gap-1">
        <p-checkbox
          [(ngModel)]="showPurchased"
          inputId="showPurchased"
          [binary]="true"
          (onChange)="doChangeShowPurchased($event)"></p-checkbox>
        <label for="showPurchased">購入完了商品を表示する</label>
      </div>
    </div>
    <div class="col-12">
      <div class="flex align-items-center gap-1">
        <p-checkbox
          [(ngModel)]="showDisplay"
          inputId="showDisplay"
          [binary]="true"
          (onChange)="reloadStocks($event)"></p-checkbox>
        <label for="showDisplay">展示商品を表示する</label>
      </div>
    </div>
    <div class="col-12">
      <div class="flex align-items-center gap-1">
        <p-checkbox
          [(ngModel)]="hideHigherPricedStores"
          inputId="hideHigherPricedStores"
          [binary]="true"
          (onChange)="onHideHigherPricedStoresChange($event)"></p-checkbox>
        <label for="hideHigherPricedStores">Amazon価格より高い店舗データを非表示</label>
      </div>
    </div>
    <div class="col-12">
      <button
        pButton
        class="p-button-outlined"
        (click)="presetDialog.open()">
        <i
          class="pi pi-bookmark"
          aria-hidden="true"></i>
        お気に入り
      </button>
    </div>
  </div>
</p-panel>
<app-store-preset-dialog
  #presetDialog
  componentName="donki"
  [currentSelection]="{ selectedArea: selectedArea, selectedStores: selectedStores }"
  (presetLoaded)="onPresetLoaded($event)"></app-store-preset-dialog>

<br />
<br />

<div class="table-header-sticky-outer">
  全{{ products.length.toLocaleString() }}件
  <p-table
    #table
    showGridlines
    [value]="products"
    columnResizeMode="expand"
    [tableStyle]="{ 'min-width': '50rem' }"
    class="table-header-sticky"
    sortMode="multiple"
    [paginator]="true"
    [rows]="30"
    [globalFilterFields]="['jan', 'asin', 'name']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-3">
            <div class="p-d-flex">
              @if (!isTestAccount) {
                <button
                  type="button"
                  pButton
                  iconOnly
                  pRipple
                  (click)="downloadCsv(table)"
                  class="p-mr-2"
                  pTooltip="CSV"
                  tooltipPosition="bottom">
                  <i
                    class="pi pi-download"
                    aria-hidden="true"></i>
                </button>
              }
            </div>
          </div>
          <div class="col-5"></div>
          <div class="col-3">
            <span class="p-input-icon-left ml-auto input-full">
              <input
                pInputText
                class="input-full"
                type="text"
                (input)="table.filterGlobal($event.target.value, 'contains')"
                placeholder="検索キーワード" />
            </span>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="table.clear()">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th width="6%">画像</th>
        <th width="10%">Keepaグラフ</th>
        <th width="9%">JAN</th>
        <th width="8%">ASIN</th>
        <th width="27%">商品名</th>
        <th width="40%">在庫状況</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-product>
      <!--<tr class="{{ getRowStyle(product) }}"> -->
      <tr>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ product.asin }}"
            target="_blank">
            <img
              src="{{ product.imageUrl }}"
              style="width: 50px" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="product.asin"></app-keepa-graph>
        </td>
        <td>
          {{ product.jan }}
          <br />
          登録日: {{ product.registrationDate | date: 'yyyy/MM/dd' }}
          <br />
          総在庫数: {{ product.totalStocks }}
          @if (product.boughtPastMonth != null) {
            <br />
            先月販売数: {{ product.boughtPastMonth < 10 ? '9以下' : product.boughtPastMonth }}
          }
        </td>
        <td>
          {{ product.asin }}
          <br />
          ({{ product.amazonPrice?.toLocaleString() }})
        </td>
        <td>
          <a
            href="https://www.amazon.co.jp/dp/{{ product.asin }}"
            target="_blank">
            {{ product.name }}
          </a>
        </td>
        <td>
          <app-spreadsheet-stock-badge
            [stocks]="product.filteredStocks"
            [showPurchased]="showPurchased"
            [showDisplay]="showDisplay"></app-spreadsheet-stock-badge>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
